module.exports = __webpack_public_path__ + "img/canal.2e48a778.png";